module.exports = __webpack_public_path__ + "static/media/logo_text.5cec0f69.jpg";